import React, { Component } from 'react';
import Table, {TableColumn} from "../Table";
import ISalamanderHostRunBlobFile from '../../models/hosted-salamander/IHostRunBlobFile';
import { TableRowProps } from '../TableRow';
import {MisDataServiceTypes} from "../../models/SchoolMailroomConfigDto";


interface MisFetchRunFilesTableProps {
    title: string;
    dataServiceType: MisDataServiceTypes;
    files?: ISalamanderHostRunBlobFile[];
}

interface MisFetchRunFilesTableState {
}

const HOST_RUN_FILE_COLUMNS: TableColumn[] = [    
    {
        title: "Name",
        propertyPath: "name",
        flex: 1,
        enableSort: false
    },
    {
        title: "Date",
        propertyPath: "createdDateTime",
        flex: 1,
        enableSort: true
    }
];

export default class MisFetchRunFilesTable extends Component<MisFetchRunFilesTableProps, MisFetchRunFilesTableState> {
    static displayName = MisFetchRunFilesTable.name;

    constructor(props: MisFetchRunFilesTableProps) {
        super(props);

        this.state = {
        }
    }
    
    render() {
        
        return (
            <Table title={this.props.title} columns={HOST_RUN_FILE_COLUMNS} items={this.props.files!} loading={this.props.files === undefined} defaultSortColumnPath="createdDateTime" rowPropsForItem={(file: ISalamanderHostRunBlobFile) => {
                const linkUrl = `/cdb-admin/mis-fetch/${file.tenantId}/${file.schoolCode}/${this.props.dataServiceType}/runs/${file.hostRunId}/${file.name}`;
                    return {
                        enableRowLink: true,
                        to: linkUrl
                    } as TableRowProps;
                }}>
                {this.props.children}
            </Table>
        );
    }
}
